'use strict';

import '@babel/polyfill';

require('./index');

new (require('./source/ui/system/WebsiteSetupTransition'))().run().then(() => {
	CK.initTransitionDone = true;
});
